<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 50 36"
    :color="color"
    title="Logo Letsbook"
    class="logo-lets"
  >
    <!-- eslint-disable max-len -->
    <path
      fill="#42403C"
      d="M12.703 10.615h6.9a.38.38 0 0 0 .38-.44c-.185-1.008-.538-1.763-1.057-2.269-.593-.575-1.438-.863-2.537-.863-2.186 0-3.538 1.029-4.057 3.086a.387.387 0 0 0 .371.486Zm-.123 2.665a.386.386 0 0 0-.378.455c.18 1.088.578 1.94 1.196 2.554.7.698 1.648 1.046 2.844 1.046.863 0 1.613-.192 2.25-.578a3.693 3.693 0 0 0 1.325-1.393.387.387 0 0 1 .45-.191l2.771.834c.223.068.342.32.238.529a7.205 7.205 0 0 1-1.483 2.022 7.363 7.363 0 0 1-2.44 1.552 7.95 7.95 0 0 1-2.905.535c-1.588 0-2.995-.347-4.22-1.04a7.315 7.315 0 0 1-2.86-2.9c-.68-1.239-1.02-2.65-1.02-4.23 0-1.708.33-3.204.992-4.488.662-1.283 1.59-2.277 2.786-2.98 1.196-.702 2.568-1.053 4.116-1.053 1.53 0 2.852.336 3.97 1.01 1.118.673 1.975 1.632 2.573 2.877.598 1.244.897 2.706.897 4.385 0 .222-.006.452-.02.692a.388.388 0 0 1-.385.362H12.58ZM30.785 7.16a.383.383 0 0 0-.384.383v6.836c0 .507.02.917.06 1.23.038.312.126.57.263.776.226.37.542.634.95.79.406.157.908.235 1.506.235.432 0 .914-.034 1.444-.1a.385.385 0 0 1 .438.377v2.198a.387.387 0 0 1-.319.38c-.841.146-1.632.22-2.372.22-1.137 0-2.132-.179-2.985-.535-.852-.356-1.489-.92-1.91-1.691a4.3 4.3 0 0 1-.5-1.42 11.126 11.126 0 0 1-.118-1.743l.015-1.347V7.543a.383.383 0 0 0-.384-.382h-2.114a.383.383 0 0 1-.384-.383V4.776c0-.211.172-.383.384-.383h2.114a.383.383 0 0 0 .384-.382V.383c0-.21.172-.382.384-.382h2.76c.212 0 .384.171.384.382v3.628c0 .211.172.382.384.382h3.893c.212 0 .384.172.384.383v2.002a.383.383 0 0 1-.384.383h-3.893ZM3.543 7.543v6.836c0 .507.02.917.06 1.23.038.312.126.57.264.776.225.37.542.634.949.79.406.157.908.235 1.506.235.433 0 .914-.034 1.444-.1a.386.386 0 0 1 .439.377v2.198a.387.387 0 0 1-.32.38c-.84.146-1.631.22-2.372.22-1.137 0-2.131-.179-2.984-.535-.853-.356-1.49-.92-1.911-1.691a4.299 4.299 0 0 1-.5-1.42A11.116 11.116 0 0 1 0 15.096l.015-1.347V.383C.015.173.187.001.4.001h2.76c.212 0 .384.171.384.382v7.16ZM38.664 19.327c-1.123-.805-1.842-1.908-2.158-3.311a.382.382 0 0 1 .32-.454l2.882-.444a.39.39 0 0 1 .428.277 2.908 2.908 0 0 0 1.138 1.523c.641.445 1.448.667 2.419.667.842 0 1.5-.169 1.97-.506.47-.336.705-.798.705-1.383 0-.381-.09-.673-.272-.879-.181-.205-.542-.407-1.08-.607-.54-.2-1.436-.466-2.69-.798-1.345-.352-2.405-.73-3.185-1.135-.778-.405-1.34-.883-1.683-1.435-.343-.551-.514-1.227-.514-2.028 0-.976.257-1.83.772-2.562.514-.732 1.244-1.298 2.19-1.698.946-.4 2.041-.6 3.286-.6 1.226 0 2.318.19 3.279.57.96.381 1.737.926 2.33 1.633.513.612.852 1.31 1.016 2.092a.38.38 0 0 1-.311.442l-2.876.513a.378.378 0 0 1-.433-.266 2.286 2.286 0 0 0-.866-1.266c-.524-.39-1.217-.61-2.08-.659-.833-.038-1.505.09-2.014.389-.51.297-.765.71-.765 1.237 0 .322.105.585.317.79.21.206.615.413 1.213.623.597.21 1.533.476 2.808.798 1.284.332 2.3.703 3.051 1.113.75.409 1.293.9 1.632 1.47.338.572.507 1.272.507 2.102 0 1.054-.262 1.964-.787 2.73-.525.767-1.279 1.355-2.264 1.765-.986.41-2.154.614-3.507.614-1.96 0-3.553-.438-4.778-1.317Z"
    />
    <path
      fill="#4AB9C7"
      d="M43.465 25.806c-.428 0-.832.208-1.07.563a15.898 15.898 0 0 1-13.221 7.039 15.898 15.898 0 0 1-13.222-7.04 1.287 1.287 0 0 0-1.07-.562c-1.035 0-1.662 1.152-1.086 2.008A18.495 18.495 0 0 0 29.174 36c6.412 0 12.059-3.25 15.377-8.186.576-.856-.05-2.008-1.086-2.008Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 50,
    },
    height: {
      type: [Number, String],
      default: 36,
    },
  },
};
</script>

<style lang="scss" scoped>
.logo-lets {
  display: block;
}
</style>
